import { render, staticRenderFns } from "./KbankAuto.vue?vue&type=template&id=09473f06&"
import script from "./KbankAuto.vue?vue&type=script&lang=js&"
export * from "./KbankAuto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports